module.exports = __webpack_public_path__ + "img/earth.be5030ca.webp";